const ACTION_LABELS = Object.freeze({
  product_created: "Cargó un ítem",
  product_updated: "Actualizó un ítem",
  product_deleted: "Eliminó un ítem",
  customer_created: "Creó un cliente",
  customer_updated: "Actualizó un cliente",
  customer_deleted: "Eliminó un cliente",
  order_created: "Registró un pedido",
  order_updated: "Actualizó un pedido",
  order_deleted: "Eliminó un pedido",
  appointment_created: "Registró un turno o reserva",
  appointment_updated: "Actualizó un turno o reserva",
  appointment_deleted: "Eliminó un turno o reserva",
  erp_operation_created: "Registró una operación",
  erp_operation_updated: "Actualizó una operación",
  erp_operation_deleted: "Eliminó una operación",
  cash_operation_created: "Registró una operación de caja",
  cash_operation_updated: "Actualizó una operación de caja",
  stock_movement_created: "Registró un movimiento de stock",
  stock_movement_updated: "Actualizó un movimiento de stock",
  membership_payment_recorded: "Registró un cobro de membresía",
  membership_paused: "Pausó una membresía",
  membership_resumed: "Reanudó una membresía",
  membership_cancelled: "Canceló una membresía",
  landing_editor_save_completed: "Guardó cambios en la página",
  landing_editor_save_failed: "No pudo guardar cambios en la página",
  order_confirmed: "Un visitante confirmó un pedido",
  cart_add: "Un visitante agregó un ítem al carrito",
  cart_remove: "Un visitante quitó un ítem del carrito",
  whatsapp_click: "Un visitante abrió WhatsApp",
  phone_click: "Un visitante tocó el teléfono",
  email_click: "Un visitante abrió el email",
});

const ROUTE_LABELS = [
  [/\/sistema\/movimientos(?:\?|$)/, "Ventas y movimientos"],
  [/\/sistema\/items(?:\?|$)/, "Ítems del negocio"],
  [/\/sistema(?:\?|$)/, "Gestión del negocio"],
  [/\/clientes(?:\?|$)/, "Clientes"],
  [/\/productos(?:\?|$)/, "Productos y servicios"],
  [/\/pedidos(?:\?|$)/, "Pedidos"],
  [/\/agenda(?:\?|$)/, "Agenda"],
  [/\/mesas(?:\?|$)/, "Mesas y reservas"],
  [/\/actividad(?:\?|$)/, "Actividad"],
  [/\/estadisticas(?:\?|$)/, "Estadísticas"],
  [/\/configuracion\/suscripcion(?:\?|$)/, "Plan y suscripción"],
  [/\/configuracion\/ecommerce(?:\?|$)/, "Cobros online"],
  [/\/configuracion\/accesos(?:\?|$)/, "Equipo y accesos"],
  [/\/configuracion(?:\/[^?]+)?(?:\?|$)/, "Configuración"],
  [/\/pagina(?:\?|$)/, "Página"],
  [/\/inicio(?:\?|$)/, "Inicio"],
  [/^\/editor-web\//, "Editor de página"],
];

export function activityActorLabel(event) {
  const actor = event?.actor || {};
  return actor.name
    || actor.email
    || (actor.type === "visitor"
      ? "Visitante web"
      : actor.type === "customer"
        ? "Cliente registrado"
        : actor.type === "webhook"
          ? "Automatización"
          : actor.type === "system"
            ? "WebProfit"
            : "Usuario del equipo");
}

export function panelRouteLabel(path = "") {
  const normalized = String(path || "").trim();
  if (!normalized) return "una sección del panel";
  const view = (() => {
    try {
      const query = normalized.includes("?") ? normalized.slice(normalized.indexOf("?")) : "";
      return new URLSearchParams(query).get("vista") || "";
    } catch {
      return "";
    }
  })();
  if (view === "ventas") return "Ventas registradas";
  if (view === "membresias") return "Membresías";
  if (view === "vencimientos") return "Vencimientos de membresías";
  if (view === "carta") return "Carta gastronómica";
  if (view === "recetas") return "Recetas e insumos";
  for (const [pattern, label] of ROUTE_LABELS) {
    if (pattern.test(normalized)) return label;
  }
  return "una sección del panel";
}

export function activityDisplayTitle(event) {
  const action = String(event?.action || "");
  if (action === "panel_route_view") return `Abrió ${panelRouteLabel(event?.journey?.path || event?.entity?.id)}`;
  return ACTION_LABELS[action] || event?.title || "Actividad registrada";
}

export function activityDisplayDescription(event) {
  const action = String(event?.action || "");
  const actor = activityActorLabel(event);
  const entityLabel = String(event?.entity?.label || "").trim();

  if (action === "panel_route_view") return `${actor} abrió ${panelRouteLabel(event?.journey?.path || event?.entity?.id)}.`;
  if (action === "product_created") return `${actor} cargó ${entityLabel && entityLabel !== "Producto o servicio" ? entityLabel : "un ítem"}.`;
  if (action === "product_updated") return `${actor} actualizó ${entityLabel && entityLabel !== "Producto o servicio" ? entityLabel : "un ítem"}.`;
  if (action === "customer_created") return `${actor} agregó un cliente al negocio.`;
  if (action === "customer_updated") return `${actor} actualizó la ficha de un cliente.`;
  if (action === "erp_operation_created") return `${actor} registró una operación en Gestión del negocio.`;
  if (action === "landing_editor_save_completed") return `${actor} guardó cambios en la página.`;
  if (action === "landing_editor_save_failed") return `${actor} intentó guardar cambios en la página y la operación falló.`;
  return event?.description || "";
}

export function activityJourneyStepLabel(step) {
  if (step?.action === "panel_route_view") return panelRouteLabel(step?.path || step?.entity?.id);
  return activityDisplayTitle(step);
}

function actorIdentity(event) {
  const actor = event?.actor || {};
  return String(actor.userId || actor.customerId || actor.visitorId || actor.email || actor.name || actor.type || "unknown");
}

export function groupActivityEvents(events = [], windowMs = 120000) {
  const groups = [];
  for (const event of events) {
    const currentAt = new Date(event?.occurredAt || event?.createdAt || 0).getTime();
    const key = [
      actorIdentity(event),
      event?.action || "",
      event?.entity?.type || "",
      event?.entity?.id || "",
    ].join("|");
    const previous = groups[groups.length - 1];
    const previousAt = previous ? new Date(previous.latest?.occurredAt || previous.latest?.createdAt || 0).getTime() : 0;
    const equivalent = previous
      && previous.matchKey === key
      && Number.isFinite(currentAt)
      && Number.isFinite(previousAt)
      && Math.abs(previousAt - currentAt) <= windowMs;

    if (equivalent) {
      previous.count += 1;
      previous.events.push(event);
      continue;
    }

    groups.push({
      key: `${key}:${event?.id || event?._id || groups.length}`,
      matchKey: key,
      latest: event,
      count: 1,
      events: [event],
    });
  }
  return groups;
}

export function activityEntityDestination(event, { projectBase = "", itemPath = "", projectKey = "" } = {}) {
  const type = String(event?.entity?.type || "").trim();
  const id = String(event?.entity?.id || "").trim();
  const metadata = event?.metadata && typeof event.metadata === "object" ? event.metadata : {};
  const customerId = String(metadata.customerId || (type === "customer" ? id : "")).trim();

  if (metadata.crmPath && String(metadata.crmPath).startsWith(`${projectBase}/`)) {
    return { path: String(metadata.crmPath), label: "Abrir CRM" };
  }
  if (type === "customer" && customerId) {
    return { path: `${projectBase}/clientes?customerId=${encodeURIComponent(customerId)}`, label: "Abrir cliente" };
  }
  if (type === "customerMembership" && customerId) {
    return { path: `${projectBase}/clientes?vista=membresias&customerId=${encodeURIComponent(customerId)}`, label: "Abrir membresía" };
  }
  if (type === "erp_movement" && id) {
    return { path: `${projectBase}/sistema/movimientos?movementId=${encodeURIComponent(id)}`, label: "Abrir movimiento" };
  }
  if (type === "product" && itemPath) {
    return { path: itemPath, label: "Abrir ítems" };
  }
  if (type === "order") {
    return { path: `${projectBase}/pedidos`, label: "Abrir pedidos" };
  }
  if (type === "appointment") {
    return { path: `${projectBase}/agenda`, label: "Abrir agenda" };
  }
  if (["landing_editor", "landing_editor_step"].includes(type) && projectKey) {
    return { path: `/editor-web/${encodeURIComponent(projectKey)}`, label: "Abrir editor" };
  }
  return null;
}
